/**
 * Created by vivi on 2018/3/14 .
 */
import React, { Component, PureComponent } from 'react';
import './index.less';
import { arrayIsVoid } from 'utils';
import HeaderWithLogo from '../HeaderWithLogo';

import { Tabs } from 'antd';
const TabPane = Tabs.TabPane;
class RootMemu extends (PureComponent || Component) {
	renderNavItem = (arr, prefixCls, activeItem) => {
		return (
			<Tabs
				activeKey={activeItem}
				tabBarGutter={60} size={'large'}
				onChange={(activeKey) => this.props.onChange(activeKey)}
			>
				{
					arr.map(
						(v, i) => <TabPane tab={v.name} key={`${i}`} />
					)
				}
  			</Tabs>
		);
	}
	render () {
		const { title, navArr, activeItem, type } = this.props;
		const prefixCls = type ? 'eh-root-memu-component-sm' : 'eh-root-memu-component';
		return (
			<div className={prefixCls}>
				<HeaderWithLogo type={type} title={title}>
					{
						arrayIsVoid(navArr)
							? this.renderNavItem(navArr, prefixCls, activeItem)
							: false
					}
				</HeaderWithLogo>
			</div>
		);
	}
}

export default RootMemu;
